module.exports = __webpack_public_path__ + "static/media/dark.79be0e92.png";